class Cache
{
  constructor ()
  {
    this.prefix = 'donor-cache-';
  }

  get (key)
  {
    if (!window.localStorage) {
      return null;
    }

    let data = null;

    try {
      data = window.localStorage.getItem(this.prefix + key);
    } catch (e) {
      console.error(e);

      return null;
    }

    if (typeof(data) !== 'undefined' && data !== null && data.length) {
      const json = JSON.parse(data);
      const now = (new Date()).getTime();

      // Check cache time is valid
      if (typeof(json.ttl) !== 'undefined') {
        if (now - json.ttl < 0) {
          return json.data;
        }

        // Expired
        this.forget(key);
      } else {
        return json.data;
      }
    }

    return null;
  }

  put (key, obj, seconds)
  {
    if (!window.localStorage) {
      return;
    }

    const data = {
      data: obj
    };

    // Time to live for cache
    if (typeof(seconds) !== 'undefined') {
      data.ttl = (new Date()).getTime() + seconds * 1000;
    }

    try {
      window.localStorage.setItem(this.prefix + key, JSON.stringify(data));
    } catch (e) {
      console.error(e);
    }
  }

  forever (key, obj)
  {
    this.put(key, obj);
  }

  forget (key)
  {
    if (!window.localStorage) {
      return;
    }

    try {
      window.localStorage.removeItem(this.prefix + key);
    } catch (e) {
      console.error(e);
    }
  }

  flush ()
  {
    if (!window.localStorage) {
      return;
    }

    for (let i = 0, len = window.localStorage.length; i < len; ++i) {
      if (window.localStorage.key(i) && window.localStorage.key(i).startsWith(this.prefix)) {
        window.localStorage.removeItem(window.localStorage.key(i));
      }
    }
  }

  keys ()
  {
    if (!window.localStorage) {
      return;
    }

    const keys = [];

    for (let i = 0, len = window.localStorage.length; i < len; ++i) {
      if (window.localStorage.key(i) && window.localStorage.key(i).startsWith(this.prefix)) {
        keys.push(window.localStorage.key(i).substring(this.prefix.length));
      }
    }

    return keys;
  }

  forgetExpired ()
  {
    this.keys().forEach(key => {
      const data = window.localStorage.getItem(this.prefix + key);

      if (typeof(data !== 'undefined') && data !== null && data.length) {
        const json = JSON.parse(data);
        const now = (new Date()).getTime();

        // Check cache time is valid
        if (typeof(json.ttl) !== 'undefined') {
          if (now - json.ttl < 0) {
            return;
          }

          // Expired
          this.forget(key);
        }
      }
    });
  }

  size ()
  {
    return this.toHumanSize(new Blob(Object.values(localStorage)).size);
  }

  toHumanSize (size)
  {
    const i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));

    return +((size / Math.pow(1024, i)).toFixed(2)) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
  }
}